module.exports = "img{\r\n    max-width:100%;\r\n    width:100%;\r\n}\r\n\r\n@media print {\r\n    .header, .navbar, #u-menu, .back-ground{\r\n        display: none !important;\r\n    }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/header/header.component.css
// module id = ./src/app/common/header/header.component.css
// module chunks = main